import React, { useState } from 'react'
import AgeCalculator from './component/AgeCalculator'
import AgeResult from './component/AgeResult'
import { differenceInYears ,differenceInDays,differenceInMonths } from 'date-fns'

const App = () => {
  const[age,setAge]=useState(null)
  const calculateAge=(birth)=>{
    const today = new Date()
    const birthobj = new Date(birth)
   const AgeYears=differenceInYears(today,birthobj)
   const AgeMonths=differenceInMonths(today,birthobj)
   const AgeDays=differenceInDays(today,birthobj)
   
   setAge({
  years:AgeYears,
  months:AgeMonths,
  days:AgeDays
   })

   }
  

  return (
    <div >
 <section className="bg-white dark:bg-gray-900">
    <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 ">
        {/* <div className="flex flex-col justify-center"> */}
            <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Age Calculator</h1>
            <p className="mb-8 text-lg font-normal text-gray-500 lg:text-xl dark:text-gray-400">Age calculator is an online tool with which you can find out your age using your date of birth and the current date</p><br/>
            <AgeCalculator calculateAge={calculateAge}/>
     {age &&  <AgeResult    age={age}/>}
        </div>
       
    {/* </div> */}
</section></div>

    
  )
}

export default App
